module.exports = __webpack_public_path__ + "img/TOM.79cfc97e.svg";